var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"async-loader",attrs:{"rotate":-90,"size":"100","width":2,"indeterminate":"","color":"primary"}},[_vm._v(" Loading... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }